import apiService from '../../../../../../service/Api'

const DONATIONS_PATH = '/api/chema/donations'

export interface PayPalInitiatePayload {
  amount: number
  donor_name?: string
  email?: string
  is_anonymous?: boolean
  stream_id?: number | null
  type_of_donation_id?: number | null
  campaign_id?: number | null
}

export interface PayPalInitiateResponse {
  success: boolean
  order_id: string
  donation_id: number
}

export interface PayPalCaptureResponse {
  success: boolean
  donation_id: number
  status: string
}

export async function initiatePayPalChemaDonation(
  payload: PayPalInitiatePayload,
): Promise<PayPalInitiateResponse> {
  const res = await apiService.post<PayPalInitiateResponse>(
    `${DONATIONS_PATH}/initiate/paypal/`,
    payload,
    true, // skipAuth — donations endpoint is public
  )
  return res.data
}

export async function capturePayPalChemaDonation(
  donationId: number,
): Promise<PayPalCaptureResponse> {
  const res = await apiService.post<PayPalCaptureResponse>(
    `${DONATIONS_PATH}/${donationId}/capture/paypal/`,
    {},
    true,
  )
  return res.data
}

export interface ZimswitchInitiatePayload {
  amount: number
  currency?: string
  donor_name?: string
  email?: string
  is_anonymous?: boolean
  stream_id?: number | null
  type_of_donation_id?: number | null
  campaign_id?: number | null
}

export interface ZimswitchInitiateResponse {
  success: boolean
  checkout_id: string
  donation_id: number
}

export interface ZimswitchVerifyResponse {
  success: boolean
  donation_id: number
  status: string
  code: string
}

export async function initiateZimswitchChemaDonation(
  payload: ZimswitchInitiatePayload,
): Promise<ZimswitchInitiateResponse> {
  const res = await apiService.post<ZimswitchInitiateResponse>(
    `${DONATIONS_PATH}/initiate/zimswitch/`,
    payload,
    true, // skipAuth — donations endpoint is public
  )
  return res.data
}

export async function verifyZimswitchChemaDonation(
  donationId: number,
  resourcePath: string,
): Promise<ZimswitchVerifyResponse> {
  const res = await apiService.post<ZimswitchVerifyResponse>(
    `${DONATIONS_PATH}/${donationId}/zimswitch/status/`,
    { resource_path: resourcePath },
    true,
  )
  return res.data
}

// EFT PAY (EFT Corp / NMBZ OPPWA COPY&PAY). Same COPY&PAY flow as ZimSwitch, but
// scoped by channel: 'card' (Visa, USD) or 'ecocash' (mobile money, USD/ZWG).
export type EftpayChannel = 'card' | 'ecocash'

export interface EftpayInitiatePayload {
  amount: number
  channel: EftpayChannel
  currency?: string
  donor_name?: string
  email?: string
  is_anonymous?: boolean
  stream_id?: number | null
  type_of_donation_id?: number | null
  campaign_id?: number | null
}

export interface EftpayInitiateResponse {
  success: boolean
  checkout_id: string
  donation_id: number
}

export interface EftpayVerifyResponse {
  success: boolean
  donation_id: number
  status: string
  code: string
}

export async function initiateEftpayChemaDonation(
  payload: EftpayInitiatePayload,
): Promise<EftpayInitiateResponse> {
  const res = await apiService.post<EftpayInitiateResponse>(
    `${DONATIONS_PATH}/initiate/eftpay/`,
    payload,
    true, // skipAuth — donations endpoint is public
  )
  return res.data
}

export async function verifyEftpayChemaDonation(
  donationId: number,
  resourcePath: string,
): Promise<EftpayVerifyResponse> {
  const res = await apiService.post<EftpayVerifyResponse>(
    `${DONATIONS_PATH}/${donationId}/eftpay/status/`,
    { resource_path: resourcePath },
    true,
  )
  return res.data
}
